"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _activeView = require("./activeView");
Object.keys(_activeView).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _activeView[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _activeView[key];
    }
  });
});